export const rfi1RawMaterialSectionMapper = {
  //Business Capabilities
  raw_material_capabilities:
    'dynamic_sections.business_capability.raw_material_capabilities',

  rnd_and_design_section:
    'dynamic_sections.business_capability.rnd_and_design_section',
  design_trend_rnd_capabilities:
    'dynamic_sections.business_capability.design_trend_rnd_capabilities',

  certifications: 'dynamic_sections.business_capability.certifications',

  lab_availability_and_management:
    'dynamic_sections.business_capability.lab_availability_and_management',
  cop_expansion_plan: 'dynamic_sections.business_capability.cop_expansion_plan',

  //Supply Chain
  top_target_vendors: 'dynamic_sections.supply_chain.top_target_vendors',
  raw_material_top_cop: 'dynamic_sections.supply_chain.raw_material_top_cop',

  //Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',

  //Other Information
  supplier_types: 'dynamic_sections.other_information.supplier_types',
  business_category_penetration:
    'dynamic_sections.other_information.business_category_penetration',
  brand_customer_penetration:
    'dynamic_sections.other_information.brand_customer_penetration',
}
